module.exports = __webpack_public_path__ + "static/media/program3.a19c9af3.jpg";